// extracted by mini-css-extract-plugin
export default {"loadingSpinnerContainer":"RedirectPage_loadingSpinnerContainer__hnVep"};